const $win = $(window)
const $maxHeightElem = $('.js-max-height-container .js-max-height-elem')
const MOBILE_WIDTH = 767

$win.on('load', function() {
  if ($maxHeightElem.length) {
    $maxHeightElem.each(function() {
      const $this = $(this)
      const $maxHeightContainer = $this.closest('.js-max-height-container')
      const maxHeightDesktop = parseInt($maxHeightContainer.attr('data-js-max-height-desktop'))
      const maxHeightMobile = parseInt($maxHeightContainer.attr('data-js-max-height-mobile'))
      let maxHeight = maxHeightDesktop
      const elemHeight = $this.outerHeight()

      if ($win.width() <= MOBILE_WIDTH) {
        maxHeight = maxHeightMobile
      }

      if (elemHeight >= maxHeight) {
        const additionalClass = $maxHeightContainer.attr('data-js-max-height-class');
        $maxHeightContainer.addClass(additionalClass)
        $this.css('max-height', maxHeight + 'px')
      }
    })
  }
})
